export default __webpack_public_path__ + "static/media/AffordabilityLevel.50a6576e.svg";